import { Role } from 'src/app/theme/shared/_helpers/role';

export interface NavigationItem {
    id: string;
    title: string;
    type: 'item' | 'collapse' | 'group';
    translate?: string;
    icon?: string;
    hidden?: boolean;
    url?: string;
    classes?: string;
    exactMatch?: boolean;
    external?: boolean;
    target?: boolean;
    breadcrumbs?: boolean;
    badge?: {
        title?: string;
        type?: string;
    };
    children?: NavigationItem[];
    role?: string[];
    disabled?: boolean;
    isMainParent?: boolean; // specify if item is main parent
}

export const NavigationItems: NavigationItem[] = [
    {
        id: 'common_masters',
        title: 'Common Masters',
        type: 'group',
        icon: 'feather icon-settings',
        role: [Role.admin, Role.Admin, Role.superadmin],
        children: [
            {
                id: 'master',
                title: 'Master',
                type: 'collapse',
                icon: 'feather icon-briefcase',
                role: [Role.admin, Role.Admin, Role.superadmin],
                children: [
                    {
                        id: 'user-master',
                        title: 'User List',
                        type: 'item',
                        url: '/mnt/trans/assets/user-master/list'
                    },
                    {
                        id: 'tenant-list',
                        title: 'Unit List',
                        type: 'item',
                        url: '/com_md/masters/tenant/list'
                    },
                    // {
                    //   id: 'department-master',
                    //   title: 'Department List',
                    //   type: 'item',
                    //   url: '/mnt/masters/department/list'
                    // },
                    {
                        id: 'color',
                        title: 'Color',
                        type: 'item',
                        url: '/com_md/masters/color/list'
                    },

                    {
                        id: 'buyer',
                        title: 'Buyer',
                        type: 'item',
                        url: '/com_md/masters/buyer/list'
                    },

                    {
                        id: 'buyer_style_no',
                        title: 'Buyer Style No',
                        type: 'item',
                        url: '/com_md/masters/buyer_style_no/list'
                    },

                    {
                        id: 'cmp_accounts',
                        title: 'Company Accounts',
                        type: 'item',
                        url: '/com_md/masters/cmp_accounts/list'
                    },

                    {
                        id: 'currency',
                        title: 'Currency',
                        type: 'item',
                        url: '/com_md/masters/currency/list'
                    },

                    {
                        id: 'fabric_type',
                        title: 'Fabric Type',
                        type: 'item',
                        url: '/com_md/masters/fabric-type/list'
                    },

                    {
                        id: 'finish_fabric',
                        title: 'Finish Fabric',
                        type: 'item',
                        url: '/com_md/masters/finish-fabric/list'
                    },

                    {
                        id: 'gray_fabric_type',
                        title: 'Gray Fabric Type',
                        type: 'item',
                        url: '/com_md/masters/gray-fabric-type/list'
                    },

                    {
                        id: 'hsn',
                        title: 'HSN',
                        type: 'item',
                        url: '/com_md/masters/hsn/list'
                    },

                    {
                        id: 'merchant',
                        title: 'Merchant',
                        type: 'item',
                        url: '/com_md/masters/merchant/list'
                    },

                    {
                        id: 'mm',
                        title: 'MM',
                        type: 'item',
                        url: '/com_md/masters/mm/list'
                    },

                    {
                        id: 'order_style_no',
                        title: 'Order Style No',
                        type: 'item',
                        url: '/com_md/masters/order_style_no/list'
                    },

                    {
                        id: 'sample_style_no',
                        title: 'Sample Style No',
                        type: 'item',
                        url: '/com_md/masters/sample_style_no/list'
                    },

                    {
                        id: 'party',
                        title: 'Party',
                        type: 'item',
                        url: '/com_md/masters/party/list'
                    },

                    {
                        id: 'season',
                        title: 'Season',
                        type: 'item',
                        url: '/com_md/masters/season/list'
                    },

                    {
                        id: 'size',
                        title: 'Size',
                        type: 'item',
                        url: '/com_md/masters/size/list'
                    },

                    {
                        id: 'size-group',
                        title: 'Size Group',
                        type: 'item',
                        url: '/com_md/masters/size-group/list'
                    },

                    {
                        id: 'style_type',
                        title: 'Style Type',
                        type: 'item',
                        url: '/com_md/masters/style_type/list'
                    },

                    {
                        id: 'uom',
                        title: 'UOM',
                        type: 'item',
                        url: '/com_md/masters/uom/list'
                    },

                    {
                        id: 'hsn',
                        title: 'HSN',
                        type: 'item',
                        url: '/com_md/masters/hsn/list'
                    },
                    {
                        id: 'fabric_type',
                        title: 'Fabric Type',
                        type: 'item',
                        url: '/com_md/masters/fabric-type/list'
                    },
                    {
                        id: 'finish_fabric',
                        title: 'Finish Fabric',
                        type: 'item',
                        url: '/com_md/masters/finish-fabric/list'
                    },
                    {
                        id: 'gray_fabric_type',
                        title: 'Gray Fabric Type',
                        type: 'item',
                        url: '/com_md/masters/gray-fabric-type/list'
                    }
                ]
            }
        ]
    },
    {
        id: 'fabric',
        title: 'Fabric',
        type: 'group',
        icon: 'feather icon-settings',
        role: [Role.admin, Role.Admin, Role.superadmin, Role.user, Role.User],
        children: [
            {
                id: 'fabric_trans',
                title: 'Fabric',
                type: 'collapse',
                icon: 'feather icon-briefcase',
                role: [Role.admin, Role.Admin, Role.superadmin, Role.user, Role.User],
                children: [
                    {
                        id: 'defect_mas',
                        title: 'Defect Master',
                        type: 'item',
                        url: '/fabric/masters/defect_mas/list'
                    },
                    {
                        id: 'defect_category',
                        title: 'Defect Category Master',
                        type: 'item',
                        url: '/fabric/masters/defect_category/list'
                    },
                    {
                        id: 'fabric_godown',
                        title: 'Fabric Godown Master',
                        type: 'item',
                        url: '/fabric/masters/fabric_godown/list'
                    },
                    {
                        id: 'rack_mas',
                        title: 'Rack Master',
                        type: 'item',
                        url: '/fabric/masters/rack_mas/list'
                    },
                    {
                        id: 'embellishment',
                        title: 'Embellishment Master',
                        type: 'item',
                        url: '/fabric/masters/embellishment/list'
                    },
                    {
                        id: 'fab_grn_list',
                        title: 'Fabric Grn List',
                        type: 'item',
                        url: '/fabric/trans/fab_grn/list'
                    },
                    {
                        id: 'emblish_capacity_entry',
                        title: 'Emblish Capacity Entry',
                        type: 'item',
                        url: '/fabric/trans/emblish_capacity_entry/list'
                    },
                    {
                        id: 'capacity_entry',
                        title: 'Production Capacity Entry',
                        type: 'item',
                        url: '/fabric/trans/prod_capacity_entry/list'
                    },
                    {
                        id: 'order_entry',
                        title: 'Order Entry',
                        type: 'item',
                        url: '/fabric/trans/order_entry/list'
                    },
                    {
                        id: 'marker_cutting_rep',
                        title: 'Marker Cuttong Rep',
                        type: 'item',
                        url: '/fabric/reports/marker_cutting_report/list'
                    },

                ]
            }
        ]
    },
    {
        id: 'cutting',
        title: 'Cutting',
        type: 'group',
        icon: 'feather icon-settings',
        role: [Role.admin, Role.Admin, Role.superadmin, Role.user, Role.User],
        children: [
            {
                id: 'cutting_room',
                title: 'Cutting Room',
                type: 'collapse',
                icon: 'feather icon-briefcase',
                role: [Role.admin, Role.Admin, Role.superadmin, Role.user, Role.User],
                children: [
                    {
                        id: 'po_plan',
                        title: 'Po Plan',
                        type: 'item',
                        url: '/fabric/trans/pri_plan/list'
                    },
                    {
                        id: 'cutting_room',
                        title: 'Cutting Room',
                        type: 'item',
                        url: '/fabric/trans/cutting_room/list'
                    },
                    {
                        id: 'ply_creation',
                        title: 'Ply Creation',
                        type: 'item',
                        url: '/fabric/trans/ply_creation/list'
                    },
                    {
                        id: 'fab_req',
                        title: 'Fabric Request',
                        type: 'item',
                        url: '/fabric/trans/fab_req/list'
                    },
                    {
                        id: 'fab_issue',
                        title: 'Fabric Issue',
                        type: 'item',
                        url: '/fabric/trans/fab_issue/list'
                    },
                    {
                        id: 'lot_plan',
                        title: 'Lot Planning',
                        type: 'item',
                        url: '/fabric/trans/lot_plan/list'
                    },
                    {
                        id: 'layer_entry',
                        title: 'Layer entry',
                        type: 'item',
                        url: '/fabric/trans/lay_entry/list'
                    },
                    {
                        id: 'numbering_bundling',
                        title: 'Numbering & Bundling',
                        type: 'item',
                        url: '/fabric/trans/bn/list'
                    },
                    {
                        id: 'issue_to_supermarket',
                        title: 'Supermarket',
                        type: 'item',
                        url: '/fabric/trans/rec_sm/list'
                    },
                    {
                        id: 'issue_to_line',
                        title: 'Issue to line',
                        type: 'item',
                        url: '/fabric/trans/issue_line/list'
                    },
                    {
                        id: 'transfer_entry',
                        title: 'Transfer Entry',
                        type: 'item',
                        url: '/fabric/trans/prod_trans/list'
                    },
                    {
                        id: 'production_entry',
                        title: 'Production',
                        type: 'item',
                        url: '/fabric/trans/prod/list'
                    }
                ]
            }
        ]
    }
    // {
    //   id: 'maintenance',
    //   title: 'Maintenance',
    //   type: 'group',
    //   icon: 'feather icon-tool',
    //   role: [Role.admin, Role.Admin, Role.superadmin, Role.user, Role.User],
    //   children: [
    //     {
    //       id: 'assets',
    //       title: 'Assets',
    //       type: 'collapse',
    //       icon: 'feather icon-settings',
    //       role: [Role.admin, Role.Admin, Role.superadmin, Role.user, Role.User],
    //       children: [
    //         {
    //           id: 'assets-list',
    //           title: 'Assets-List',
    //           type: 'item',
    //           url: '/mnt/trans/assets/list'
    //         },
    //         {
    //           id: 'assets-transfer',
    //           title: 'Asset Transfer',
    //           type: 'item',
    //           url: '/mnt/trans/assets/transfer'
    //         },
    //         {
    //           id: 'assets-requisition',
    //           title: 'Requisition',
    //           type: 'item',
    //           url: '/mnt/trans/assets/requisition'
    //         },
    //         {
    //           id: 'transfer-approval',
    //           title: 'Transfer Approval',
    //           type: 'item',
    //           url: '/mnt/trans/assets/transfer-approval'
    //         }
    //       ]
    //     },
    //     {
    //       id: 'master-items',
    //       title: 'Master',
    //       type: 'collapse',
    //       icon: 'feather icon-database',
    //       role: [Role.admin, Role.Admin, Role.superadmin, Role.user, Role.User],
    //       children: [
    //         {
    //           id: 'model-number-master',
    //           title: 'Model Number',
    //           type: 'item',
    //           url: '/mnt/masters/model-number/list'
    //         },
    //         {
    //           id: 'location-master',
    //           title: 'Location',
    //           type: 'item',
    //           url: '/mnt/masters/location/list'
    //         },
    //         // {
    //         //   id: 'department-master',
    //         //   title: 'Department',
    //         //   type: 'item',
    //         //   url: '/mnt/masters/department/list'
    //         // },
    //         {
    //           id: 'category-master',
    //           title: 'Category',
    //           type: 'item',
    //           url: '/mnt/masters/category/list'
    //         },
    //         {
    //           id: 'amc-contract-master',
    //           title: 'AMC Contract',
    //           type: 'item',
    //           url: '/mnt/masters/amc-contract/list'
    //         },
    //         {
    //           id: 'amc-mapping',
    //           title: 'AMC Mapping',
    //           type: 'item',
    //           url: '/mnt/masters/amc-mapping/list'
    //         },
    //         {
    //           id: 'depreciation-master',
    //           title: 'Depreciation',
    //           type: 'item',
    //           url: '/mnt/masters/depreciation/list'
    //         },
    //         {
    //           id: 'activity-logs',
    //           title: 'Activity Logs',
    //           type: 'item',
    //           url: '/mnt/masters/activity-logs/list'
    //         },
    //         {
    //           id: 'user-master',
    //           title: 'User Master',
    //           type: 'item',
    //           url: '/mnt/trans/assets/user-master/list'
    //         }
    //       ]
    //     }
    //   ]
    // }

    // {
    //   id: 'navigation',
    //   title: 'Navigation',
    //   type: 'group',
    //   icon: 'feather icon-monitor',
    //   role: [Role.admin, Role.Admin, Role.superadmin, Role.user, Role.User],
    //   children: [
    //     {
    //       id: 'dashboard',
    //       title: 'Dashboard',
    //       type: 'collapse',
    //       icon: 'feather icon-home',
    //       role: [Role.admin, Role.Admin, Role.superadmin, Role.user, Role.User],
    //       children: [
    //         {
    //           id: 'analytics',
    //           title: 'Analytics',
    //           type: 'item',
    //           url: '/dashboard/analytics'
    //         },
    //         {
    //           id: 'sale',
    //           title: 'Sales',
    //           type: 'item',
    //           url: '/dashboard/sale'
    //         },
    //         {
    //           id: 'finance',
    //           title: 'Finance',
    //           type: 'item',
    //           url: '/dashboard/finance',
    //           role: [Role.admin, Role.Admin, Role.superadmin]
    //         }
    //       ]
    //     },
    //     {
    //       id: 'page-layouts',
    //       title: 'Page Layouts',
    //       type: 'collapse',
    //       icon: 'feather icon-layout',
    //       role: [Role.admin, Role.Admin, Role.superadmin, Role.user, Role.User],
    //       children: [
    //         {
    //           id: 'vertical',
    //           title: 'Vertical',
    //           type: 'collapse',
    //           role: [Role.admin, Role.Admin, Role.superadmin, Role.user, Role.User],
    //           children: [
    //             {
    //               id: 'v-static',
    //               title: 'Static',
    //               type: 'item',
    //               url: '/layout/static',
    //               target: true
    //             },
    //             {
    //               id: 'v-fixed',
    //               title: 'Fixed',
    //               type: 'item',
    //               url: '/layout/fixed',
    //               target: true
    //             },
    //             {
    //               id: 'v-nav-fixed',
    //               title: 'Navbar Fixed',
    //               type: 'item',
    //               url: '/layout/nav-fixed',
    //               target: true
    //             },
    //             {
    //               id: 'v-collapse-menu',
    //               title: 'Collapse Menu',
    //               type: 'item',
    //               url: '/layout/collapse-menu',
    //               target: true
    //             },
    //             {
    //               id: 'v-rtl',
    //               title: 'Vertical RTL',
    //               type: 'item',
    //               url: '/layout/vertical-rtl',
    //               target: true
    //             }
    //           ]
    //         },
    //         {
    //           id: 'horizontal',
    //           title: 'Horizontal',
    //           type: 'item',
    //           url: '/layout/horizontal',
    //           target: true
    //         },
    //         {
    //           id: 'horizontal-l2',
    //           title: 'Horizontal v2',
    //           type: 'item',
    //           url: '/layout/horizontal-l2',
    //           target: true
    //         },
    //         {
    //           id: 'box-layout',
    //           title: 'Box Layout',
    //           type: 'item',
    //           url: '/layout/box',
    //           target: true
    //         },
    //         {
    //           id: 'light-layout',
    //           title: 'Light Layout',
    //           type: 'item',
    //           url: '/layout/light',
    //           target: true
    //         },
    //         {
    //           id: 'dark-layout',
    //           title: 'Dark Layout',
    //           type: 'item',
    //           url: '/layout/dark',
    //           target: true
    //         }
    //       ]
    //     },
    //     {
    //       id: 'widget',
    //       title: 'Widget',
    //       type: 'collapse',
    //       icon: 'feather icon-layers',
    //       role: [Role.admin, Role.Admin, Role.superadmin, Role.user, Role.User],
    //       badge: {
    //         title: '100+',
    //         type: 'bg-success'
    //       },
    //       children: [
    //         {
    //           id: 'statistic',
    //           title: 'Statistic',
    //           type: 'item',
    //           url: '/widget/statistic'
    //         },
    //         {
    //           id: 'data',
    //           title: 'Data',
    //           type: 'item',
    //           url: '/widget/data'
    //         },
    //         {
    //           id: 'chart',
    //           title: 'Chart',
    //           type: 'item',
    //           url: '/widget/chart'
    //         }
    //       ]
    //     },
    //     {
    //       id: 'users',
    //       title: 'User',
    //       type: 'collapse',
    //       icon: 'feather icon-users',
    //       role: [Role.admin, Role.Admin, Role.superadmin, Role.user, Role.User],
    //       children: [
    //         {
    //           id: 'profile',
    //           title: 'Profile',
    //           type: 'item',
    //           url: '/users/profile',
    //           breadcrumbs: false
    //         },
    //         {
    //           id: 'cards',
    //           title: 'User Card',
    //           type: 'item',
    //           url: '/users/card'
    //         },
    //         {
    //           id: 'list',
    //           title: 'User List',
    //           type: 'item',
    //           url: '/users/list'
    //         }
    //       ]
    //     }
    //   ]
    // },
    // {
    //   id: 'admin',
    //   title: 'Admin Panel',
    //   type: 'group',
    //   icon: 'icon-navigation',
    //   role: [Role.admin, Role.Admin, Role.superadmin, Role.user, Role.User],
    //   children: [
    //     {
    //       id: 'Online-Courses',
    //       title: 'Online Courses',
    //       type: 'collapse',
    //       icon: 'feather icon-book',
    //       role: [Role.admin, Role.Admin, Role.superadmin, Role.user, Role.User],
    //       children: [
    //         {
    //           id: 'dashboard',
    //           title: 'Dashboard',
    //           type: 'item',
    //           url: '/online-course/dashboard',
    //           role: [Role.admin, Role.Admin, Role.superadmin]
    //         },
    //         {
    //           id: 'teacher',
    //           title: 'Teacher',
    //           type: 'collapse',
    //           role: [Role.admin, Role.Admin, Role.superadmin, Role.user, Role.User],
    //           children: [
    //             {
    //               id: 'list',
    //               title: 'List',
    //               type: 'item',
    //               url: '/online-course/teacher/list'
    //             },
    //             {
    //               id: 'apply',
    //               title: 'Apply',
    //               type: 'item',
    //               url: '/online-course/teacher/apply'
    //             },
    //             {
    //               id: 'add',
    //               title: 'Add',
    //               type: 'item',
    //               url: '/online-course/teacher/add',
    //               role: [Role.admin, Role.Admin, Role.superadmin]
    //             }
    //           ]
    //         },
    //         {
    //           id: 'student',
    //           title: 'Student',
    //           type: 'collapse',
    //           role: [Role.admin, Role.Admin, Role.superadmin, Role.user, Role.User],
    //           children: [
    //             {
    //               id: 'list',
    //               title: 'List',
    //               type: 'item',
    //               url: '/online-course/student/list'
    //             },
    //             {
    //               id: 'apply',
    //               title: 'Apply',
    //               type: 'item',
    //               url: '/online-course/student/apply'
    //             },
    //             {
    //               id: 'add',
    //               title: 'Add',
    //               type: 'item',
    //               url: '/online-course/student/add',
    //               role: [Role.admin, Role.Admin, Role.superadmin]
    //             }
    //           ]
    //         },
    //         {
    //           id: 'courses',
    //           title: 'Courses',
    //           type: 'collapse',
    //           role: [Role.admin, Role.Admin, Role.superadmin, Role.user, Role.User],
    //           children: [
    //             {
    //               id: 'view',
    //               title: 'View',
    //               type: 'item',
    //               url: '/online-course/courses/view'
    //             },
    //             {
    //               id: 'add',
    //               title: 'Add',
    //               type: 'item',
    //               url: '/online-course/courses/add',
    //               role: [Role.admin, Role.Admin, Role.superadmin]
    //             }
    //           ]
    //         },
    //         {
    //           id: 'pricing',
    //           title: 'Pricing',
    //           type: 'item',
    //           url: '/online-course/pricing'
    //         },
    //         {
    //           id: 'site',
    //           title: 'Site',
    //           type: 'item',
    //           url: '/online-course/site'
    //         },
    //         {
    //           id: 'setting',
    //           title: 'Setting',
    //           type: 'collapse',
    //           role: [Role.admin, Role.Admin, Role.superadmin, Role.user, Role.User],
    //           children: [
    //             {
    //               id: 'payment',
    //               title: 'Payment',
    //               type: 'item',
    //               url: '/online-course/setting/payment'
    //             },
    //             {
    //               id: 'pricing',
    //               title: 'Pricing',
    //               type: 'item',
    //               url: '/online-course/setting/price'
    //             },
    //             {
    //               id: 'notification',
    //               title: 'Notification',
    //               type: 'item',
    //               url: '/online-course/setting/notification'
    //             }
    //           ]
    //         }
    //       ]
    //     },
    //     {
    //       id: 'membership',
    //       title: 'Membership',
    //       type: 'collapse',
    //       icon: 'feather icon-users',
    //       role: [Role.admin, Role.Admin, Role.superadmin, Role.user, Role.User],
    //       children: [
    //         {
    //           id: 'dashboard',
    //           title: 'Dashboard',
    //           type: 'item',
    //           url: '/membership/dashboard',
    //           role: [Role.admin, Role.Admin, Role.superadmin]
    //         },
    //         {
    //           id: 'list',
    //           title: 'List',
    //           type: 'item',
    //           url: '/membership/list'
    //         },
    //         {
    //           id: 'price',
    //           title: 'Pricing',
    //           type: 'item',
    //           url: '/membership/price'
    //         },
    //         {
    //           id: 'setting',
    //           title: 'Setting',
    //           type: 'item',
    //           url: '/membership/setting'
    //         }
    //       ]
    //     },
    //     {
    //       id: 'helpdesk',
    //       title: 'Helpdesk',
    //       type: 'collapse',
    //       icon: 'feather icon-help-circle',
    //       role: [Role.admin, Role.Admin, Role.superadmin, Role.user, Role.User],
    //       children: [
    //         {
    //           id: 'dashboard',
    //           title: 'Dashboard',
    //           type: 'item',
    //           url: '/helpdesk/dashboard',
    //           role: [Role.admin, Role.Admin, Role.superadmin]
    //         },
    //         {
    //           id: 'ticket',
    //           title: 'Ticket',
    //           type: 'collapse',
    //           role: [Role.admin, Role.Admin, Role.superadmin, Role.user, Role.User],
    //           children: [
    //             {
    //               id: 'create',
    //               title: 'Create',
    //               type: 'item',
    //               url: '/helpdesk/ticket/create'
    //             },
    //             {
    //               id: 'list',
    //               title: 'List',
    //               type: 'item',
    //               url: '/helpdesk/ticket/list'
    //             },
    //             {
    //               id: 'details',
    //               title: 'Details',
    //               type: 'item',
    //               url: '/helpdesk/ticket/details',
    //               role: [Role.admin, Role.Admin, Role.superadmin]
    //             }
    //           ]
    //         },
    //         {
    //           id: 'customer',
    //           title: 'Customer',
    //           type: 'item',
    //           url: '/helpdesk/customer'
    //         }
    //       ]
    //     },
    //     {
    //       id: 'invoice',
    //       title: 'Invoice',
    //       type: 'collapse',
    //       icon: 'feather icon-file-text',
    //       role: [Role.admin, Role.Admin, Role.superadmin, Role.user, Role.User],
    //       children: [
    //         {
    //           id: 'dashboard',
    //           title: 'Dashboard',
    //           type: 'item',
    //           url: '/invoice/dashboard'
    //         },
    //         {
    //           id: 'create',
    //           title: 'Create',
    //           type: 'item',
    //           url: '/invoice/create',
    //           role: [Role.admin, Role.Admin, Role.superadmin]
    //         },
    //         {
    //           id: 'details',
    //           title: 'Details',
    //           type: 'item',
    //           url: '/invoice/details'
    //         },
    //         {
    //           id: 'list',
    //           title: 'List',
    //           type: 'item',
    //           url: '/invoice/list'
    //         },
    //         {
    //           id: 'edit',
    //           title: 'Edit',
    //           type: 'item',
    //           url: '/invoice/edit',
    //           role: [Role.admin, Role.Admin, Role.superadmin]
    //         }
    //       ]
    //     }
    //   ]
    // },
    // {
    //   id: 'ui-element',
    //   title: 'UI ELEMENT',
    //   type: 'group',
    //   icon: 'feather icon-layers',
    //   role: [Role.admin, Role.Admin, Role.superadmin, Role.user, Role.User],
    //   children: [
    //     {
    //       id: 'basic',
    //       title: 'Basic',
    //       type: 'collapse',
    //       icon: 'feather icon-box',
    //       classes: 'menu-scroll',
    //       role: [Role.admin, Role.Admin, Role.superadmin, Role.user, Role.User],
    //       children: [
    //         {
    //           id: 'alert',
    //           title: 'Alert',
    //           type: 'item',
    //           url: '/basic/alert'
    //         },
    //         {
    //           id: 'button',
    //           title: 'Button',
    //           type: 'item',
    //           url: '/basic/button'
    //         },
    //         {
    //           id: 'badges',
    //           title: 'Badges',
    //           type: 'item',
    //           url: '/basic/badges'
    //         },
    //         {
    //           id: 'breadcrumb',
    //           title: 'Breadcrumbs',
    //           type: 'item',
    //           url: '/basic/breadcrumb'
    //         },
    //         {
    //           id: 'cards',
    //           title: 'Cards',
    //           type: 'item',
    //           url: '/basic/cards'
    //         },
    //         {
    //           id: 'placeholder',
    //           title: 'Placeholder',
    //           type: 'item',
    //           url: '/basic/placeholder'
    //         },
    //         {
    //           id: 'collapse',
    //           title: 'Collapse',
    //           type: 'item',
    //           url: '/basic/collapse'
    //         },
    //         {
    //           id: 'carousel',
    //           title: 'Carousel',
    //           type: 'item',
    //           url: '/basic/carousel'
    //         },
    //         {
    //           id: 'dropdowns',
    //           title: 'Dropdowns',
    //           type: 'item',
    //           url: '/basic/dropdowns'
    //         },
    //         {
    //           id: 'offcanvas',
    //           title: 'Offcanvas',
    //           type: 'item',
    //           url: '/basic/offcanvas'
    //         },
    //         {
    //           id: 'progress',
    //           title: 'Progress',
    //           type: 'item',
    //           url: '/basic/progress'
    //         },
    //         {
    //           id: 'list-group',
    //           title: 'List Group',
    //           type: 'item',
    //           url: '/basic/list-group'
    //         },
    //         {
    //           id: 'modal',
    //           title: 'Modal',
    //           type: 'item',
    //           url: '/basic/modal'
    //         },
    //         {
    //           id: 'spinner',
    //           title: 'Spinner',
    //           type: 'item',
    //           url: '/basic/spinner'
    //         },
    //         {
    //           id: 'tabs-pills',
    //           title: 'Tabs & Pills',
    //           type: 'item',
    //           url: '/basic/tabs-pills'
    //         },
    //         {
    //           id: 'typography',
    //           title: 'Typography',
    //           type: 'item',
    //           url: '/basic/typography'
    //         },
    //         {
    //           id: 'toasts',
    //           title: 'Toasts',
    //           type: 'item',
    //           url: '/basic/toasts'
    //         },
    //         {
    //           id: 'other',
    //           title: 'Other',
    //           type: 'item',
    //           url: '/basic/other'
    //         }
    //       ]
    //     },
    //     {
    //       id: 'advance',
    //       title: 'Advance',
    //       type: 'collapse',
    //       icon: 'feather icon-gitlab',
    //       role: [Role.admin, Role.Admin, Role.superadmin, Role.user, Role.User],
    //       children: [
    //         {
    //           id: 'sweet-alert',
    //           title: 'Sweet Alert',
    //           type: 'item',
    //           url: '/advance/sweetAlert'
    //         },
    //         {
    //           id: 'datepicker',
    //           title: 'Datepicker',
    //           type: 'item',
    //           url: '/advance/datepicker'
    //         },
    //         {
    //           id: 'light-box',
    //           title: 'Light Box',
    //           type: 'item',
    //           url: '/advance/lightbox'
    //         },
    //         {
    //           id: 'modal',
    //           title: 'Modal',
    //           type: 'item',
    //           url: '/advance/modal'
    //         },
    //         {
    //           id: 'notification',
    //           title: 'Notification',
    //           type: 'item',
    //           url: '/advance/notification'
    //         },
    //         {
    //           id: 'range-slider',
    //           title: 'Range Slider',
    //           type: 'item',
    //           url: '/advance/rangeSlider'
    //         },
    //         {
    //           id: 'tree-view',
    //           title: 'Tree View',
    //           type: 'item',
    //           url: '/advance/treeView'
    //         }
    //       ]
    //     }
    //   ]
    // },
    // {
    //   id: 'forms',
    //   title: 'Forms',
    //   type: 'group',
    //   icon: 'feather icon-layout',
    //   role: [Role.admin, Role.Admin, Role.superadmin, Role.user, Role.User],
    //   children: [
    //     {
    //       id: 'forms-element',
    //       title: 'Forms',
    //       type: 'collapse',
    //       icon: 'feather icon-file-text',
    //       role: [Role.admin, Role.Admin, Role.superadmin, Role.user, Role.User],
    //       children: [
    //         {
    //           id: 'form-elements',
    //           title: 'Form Elements',
    //           type: 'item',
    //           url: '/forms/basic'
    //         },
    //         {
    //           id: 'form-elements',
    //           title: 'Form Advance',
    //           type: 'item',
    //           url: '/forms/advance'
    //         },
    //         {
    //           id: 'form-validation',
    //           title: 'Form Validation',
    //           type: 'item',
    //           url: '/forms/validation'
    //         },
    //         {
    //           id: 'form-masking',
    //           title: 'Form Masking',
    //           type: 'item',
    //           url: '/forms/masking'
    //         },
    //         {
    //           id: 'form-picker',
    //           title: 'Form Picker',
    //           type: 'item',
    //           url: '/forms/picker'
    //         },
    //         {
    //           id: 'form-select',
    //           title: 'Form Select',
    //           type: 'item',
    //           url: '/forms/select'
    //         }
    //       ]
    //     }
    //   ]
    // },
    // {
    //   id: 'table',
    //   title: 'Table',
    //   type: 'group',
    //   icon: 'feather icon-list',
    //   role: [Role.admin, Role.Admin, Role.superadmin, Role.user, Role.User],
    //   children: [
    //     {
    //       id: 'bootstrap',
    //       title: 'Bootstrap Table',
    //       type: 'collapse',
    //       icon: 'feather icon-server',
    //       role: [Role.admin, Role.Admin, Role.superadmin, Role.user, Role.User],
    //       children: [
    //         {
    //           id: 'bt-basic',
    //           title: 'Basic',
    //           type: 'item',
    //           url: '/tbl-bootstrap/bt-basic'
    //         },
    //         {
    //           id: 'bt-sizing',
    //           title: 'Sizing',
    //           type: 'item',
    //           url: '/tbl-bootstrap/bt-sizing'
    //         },
    //         {
    //           id: 'bt-border',
    //           title: 'Border',
    //           type: 'item',
    //           url: '/tbl-bootstrap/bt-border'
    //         },
    //         {
    //           id: 'bt-styling',
    //           title: 'Styling',
    //           type: 'item',
    //           url: '/tbl-bootstrap/bt-styling'
    //         }
    //       ]
    //     },
    //     {
    //       id: 'ag grid-table',
    //       title: 'Ag Grid Table',
    //       type: 'collapse',
    //       icon: 'feather icon-box',
    //       role: [Role.admin, Role.Admin, Role.superadmin, Role.user, Role.User],
    //       children: [
    //         {
    //           id: 'ag-grid-basic-table',
    //           title: 'Basic',
    //           type: 'item',
    //           url: '/ag-grid-table/basic'
    //         },
    //         {
    //           id: 'column-moving-table',
    //           title: 'Column Moving',
    //           type: 'item',
    //           url: '/ag-grid-table/column-moving'
    //         },
    //         {
    //           id: 'row-pagination-table',
    //           title: 'Row Pagination',
    //           type: 'item',
    //           url: '/ag-grid-table/row-pagination'
    //         },
    //         {
    //           id: 'highlight-change-table',
    //           title: 'Highlight Change',
    //           type: 'item',
    //           url: '/ag-grid-table/highlight-change'
    //         },
    //         {
    //           id: 'column-filter-table',
    //           title: 'Column Filter',
    //           type: 'item',
    //           url: '/ag-grid-table/column-filter'
    //         }
    //       ]
    //     }
    //   ]
    // },
    // {
    //   id: 'chart-maps',
    //   title: 'Chart & Maps',
    //   type: 'group',
    //   icon: 'feather icon-pie-chart',
    //   role: [Role.admin, Role.Admin, Role.superadmin, Role.user, Role.User],
    //   children: [
    //     {
    //       id: 'charts',
    //       title: 'Charts',
    //       type: 'collapse',
    //       icon: 'feather icon-pie-chart',
    //       role: [Role.admin, Role.Admin, Role.superadmin, Role.user, Role.User],
    //       children: [
    //         {
    //           id: 'apex',
    //           title: 'Apex Chart',
    //           type: 'item',
    //           url: '/charts/apex'
    //         },
    //         {
    //           id: 'chart-js',
    //           title: 'Chart JS',
    //           type: 'item',
    //           url: '/charts/chart-js'
    //         },
    //         {
    //           id: 'peity',
    //           title: 'Peity',
    //           type: 'item',
    //           url: '/charts/peity'
    //         }
    //       ]
    //     },
    //     {
    //       id: 'maps',
    //       title: 'Maps',
    //       type: 'collapse',
    //       icon: 'feather icon-map',
    //       role: [Role.admin, Role.Admin, Role.superadmin, Role.user, Role.User],
    //       children: [
    //         {
    //           id: 'google',
    //           title: 'Google',
    //           type: 'item',
    //           url: '/maps/google'
    //         }
    //       ]
    //     }
    //   ]
    // },
    // {
    //   id: 'pages',
    //   title: 'Pages',
    //   type: 'group',
    //   icon: 'feather icon-file-text',
    //   role: [Role.admin, Role.Admin, Role.superadmin, Role.user, Role.User],
    //   children: [
    //     {
    //       id: 'auth',
    //       title: 'Authentication',
    //       type: 'collapse',
    //       icon: 'feather icon-lock',
    //       role: [Role.admin, Role.Admin, Role.superadmin, Role.user, Role.User],
    //       children: [
    //         {
    //           id: 'signup',
    //           title: 'Sign up',
    //           type: 'item',
    //           url: '/auth/register',
    //           target: true,
    //           breadcrumbs: false
    //         },
    //         {
    //           id: 'signup-v2',
    //           title: 'Sign up v2',
    //           type: 'item',
    //           url: '/auth/register2',
    //           badge: {
    //             title: 'New',
    //             type: 'bg-primary text-white'
    //           },
    //           target: true,
    //           breadcrumbs: false
    //         },
    //         {
    //           id: 'signin',
    //           title: 'Sign in',
    //           type: 'item',
    //           url: '/auth/login',
    //           target: true,
    //           breadcrumbs: false
    //         },
    //         {
    //           id: 'signin-v2',
    //           title: 'Sign in v2',
    //           type: 'item',
    //           url: '/auth/login2',
    //           badge: {
    //             title: 'New',
    //             type: 'bg-primary text-white'
    //           },
    //           target: true,
    //           breadcrumbs: false
    //         },
    //         {
    //           id: 'reset-password',
    //           title: 'Reset Password',
    //           type: 'item',
    //           url: '/auth/reset-password',
    //           target: true,
    //           breadcrumbs: false
    //         },
    //         {
    //           id: 'reset-password-v2',
    //           title: 'Reset Password v2',
    //           type: 'item',
    //           url: '/auth/reset-password-v2',
    //           target: true,
    //           breadcrumbs: false
    //         },
    //         {
    //           id: 'change-password',
    //           title: 'Change Password',
    //           type: 'item',
    //           url: '/auth/change-password',
    //           target: true,
    //           breadcrumbs: false
    //         },
    //         {
    //           id: 'change-password-v2',
    //           title: 'Change Password v2',
    //           type: 'item',
    //           url: '/auth/change-password-v2',
    //           target: true,
    //           breadcrumbs: false
    //         },
    //         {
    //           id: 'personal-information',
    //           title: 'Personal Information',
    //           type: 'item',
    //           url: '/auth/personal-information',
    //           target: true,
    //           breadcrumbs: false
    //         },
    //         {
    //           id: 'profile-settings',
    //           title: 'Profile Settings',
    //           type: 'item',
    //           url: '/auth/profile-settings',
    //           target: true,
    //           breadcrumbs: false
    //         }
    //       ]
    //     },
    //     {
    //       id: 'maintenance',
    //       title: 'Maintenance',
    //       type: 'collapse',
    //       icon: 'feather icon-sliders',
    //       role: [Role.admin, Role.Admin, Role.superadmin, Role.user, Role.User],
    //       children: [
    //         {
    //           id: 'error',
    //           title: 'Error',
    //           type: 'item',
    //           url: '/maintenance/error',
    //           target: true,
    //           breadcrumbs: false
    //         },
    //         {
    //           id: 'offline-ui',
    //           title: 'Offline UI',
    //           type: 'item',
    //           url: '/maintenance/offline-ui',
    //           target: true,
    //           breadcrumbs: false
    //         },
    //         {
    //           id: 'coming-soon',
    //           title: 'Maintenance',
    //           type: 'item',
    //           url: '/maintenance/coming-soon',
    //           target: true,
    //           breadcrumbs: false
    //         }
    //       ]
    //     },
    //     {
    //       id: 'landing',
    //       title: 'Landing',
    //       type: 'item',
    //       url: '/landing',
    //       classes: 'nav-item',
    //       icon: 'feather icon-navigation-2',
    //       target: true
    //     }
    //   ]
    // },
    // {
    //   id: 'app',
    //   title: 'App',
    //   type: 'group',
    //   icon: 'feather icon-tv',
    //   role: [Role.admin, Role.Admin, Role.superadmin, Role.user, Role.User],
    //   children: [
    //     {
    //       id: 'email',
    //       title: 'Email',
    //       type: 'collapse',
    //       icon: 'feather icon-mail',
    //       role: [Role.admin, Role.Admin, Role.superadmin, Role.user, Role.User],
    //       children: [
    //         {
    //           id: 'mail-inbox',
    //           title: 'Inbox',
    //           type: 'item',
    //           url: '/email/mail-inbox'
    //         },
    //         {
    //           id: 'mail-read',
    //           title: 'Read Mail',
    //           type: 'item',
    //           url: '/email/mail-read'
    //         },
    //         {
    //           id: 'mail-compose',
    //           title: 'Compose Mail',
    //           type: 'item',
    //           url: '/email/mail-compose'
    //         }
    //       ]
    //     },
    //     {
    //       id: 'task',
    //       title: 'Task',
    //       type: 'collapse',
    //       icon: 'feather icon-clipboard',
    //       role: [Role.admin, Role.Admin, Role.superadmin, Role.user, Role.User],
    //       children: [
    //         {
    //           id: 'task-list',
    //           title: 'List',
    //           type: 'item',
    //           url: '/task/list'
    //         },
    //         {
    //           id: 'task-board',
    //           title: 'Board',
    //           type: 'item',
    //           url: '/task/board'
    //         },
    //         {
    //           id: 'task-detail',
    //           title: 'Detail',
    //           type: 'item',
    //           url: '/task/detail'
    //         }
    //       ]
    //     },
    //     {
    //       id: 'to-dos',
    //       title: 'Todo',
    //       type: 'collapse',
    //       icon: 'feather icon-check-square',
    //       role: [Role.admin, Role.Admin, Role.superadmin, Role.user, Role.User],
    //       children: [
    //         {
    //           id: 'todo',
    //           title: 'Todo',
    //           type: 'item',
    //           url: '/todo/basic'
    //         }
    //       ]
    //     },
    //     {
    //       id: 'gallery',
    //       title: 'Gallery',
    //       type: 'collapse',
    //       icon: 'feather icon-image',
    //       role: [Role.admin, Role.Admin, Role.superadmin, Role.user, Role.User],
    //       children: [
    //         {
    //           id: 'grid',
    //           title: 'Grid',
    //           type: 'item',
    //           url: '/gallery/grid'
    //         }
    //       ]
    //     },
    //     {
    //       id: 'full-calendar',
    //       title: 'Full Calendar',
    //       type: 'item',
    //       url: '/full-calendar',
    //       classes: 'nav-item',
    //       icon: 'feather icon-calendar'
    //     }
    //   ]
    // },
    // {
    //   id: 'extension',
    //   title: 'Extension',
    //   type: 'group',
    //   icon: 'feather icon-cpu',
    //   role: [Role.admin, Role.Admin, Role.superadmin, Role.user, Role.User],
    //   children: [
    //     {
    //       id: 'editor',
    //       title: 'Editor',
    //       type: 'collapse',
    //       icon: 'feather icon-file-plus',
    //       role: [Role.admin, Role.Admin, Role.superadmin, Role.user, Role.User],
    //       children: [
    //         {
    //           id: 'quill-editor',
    //           title: 'Quill Editor',
    //           type: 'item',
    //           url: '/editor/quill-editor'
    //         },
    //         {
    //           id: 'text-editor',
    //           title: 'Text Editor',
    //           type: 'item',
    //           url: '/editor/text-editor'
    //         }
    //       ]
    //     },
    //     {
    //       id: 'invoice',
    //       title: 'Invoice',
    //       type: 'collapse',
    //       icon: 'feather icon-file-minus',
    //       role: [Role.admin, Role.Admin, Role.superadmin, Role.user, Role.User],
    //       children: [
    //         {
    //           id: 'invoice-basic',
    //           title: 'Invoice Basic',
    //           type: 'item',
    //           url: '/invoice/basic'
    //         },
    //         {
    //           id: 'invoice-summary',
    //           title: 'Invoice Summary',
    //           type: 'item',
    //           url: '/invoice/summary'
    //         },
    //         {
    //           id: 'invoice-list',
    //           title: 'Invoice List',
    //           type: 'item',
    //           url: '/invoice/list'
    //         }
    //       ]
    //     },
    //     {
    //       id: 'file-upload',
    //       title: 'File Upload',
    //       type: 'collapse',
    //       icon: 'feather icon-upload-cloud',
    //       role: [Role.admin, Role.Admin, Role.superadmin, Role.user, Role.User],
    //       children: [
    //         {
    //           id: 'dropzone',
    //           title: 'DropZone',
    //           type: 'item',
    //           url: '/file-upload/dropzone'
    //         },
    //         {
    //           id: 'file-uploader',
    //           title: 'Files Uploader',
    //           type: 'item',
    //           url: '/file-upload/files-dropzone'
    //         }
    //       ]
    //     }
    //   ]
    // },
    // {
    //   id: 'other',
    //   title: 'Other',
    //   type: 'group',
    //   icon: 'feather icon-align-left',
    //   role: [Role.admin, Role.Admin, Role.superadmin, Role.user, Role.User],
    //   children: [
    //     {
    //       id: 'menu-level',
    //       title: 'Menu Levels',
    //       type: 'collapse',
    //       icon: 'feather icon-menu',
    //       role: [Role.admin, Role.Admin, Role.superadmin, Role.user, Role.User],
    //       children: [
    //         {
    //           id: 'menu-level-2.1',
    //           title: 'Menu Level 2.1',
    //           type: 'item',
    //           url: 'javascript:',
    //           external: true
    //         },
    //         {
    //           id: 'menu-level-2.2',
    //           title: 'Menu Level 2.2',
    //           type: 'collapse',
    //           role: [Role.admin, Role.Admin, Role.superadmin, Role.user, Role.User],
    //           children: [
    //             {
    //               id: 'menu-level-2.2.1',
    //               title: 'Menu Level 2.2.1',
    //               type: 'item',
    //               url: 'javascript:',
    //               external: true
    //             },
    //             {
    //               id: 'menu-level-2.2.2',
    //               title: 'Menu Level 2.2.2',
    //               type: 'item',
    //               url: 'javascript:',
    //               external: true
    //             }
    //           ]
    //         }
    //       ]
    //     },
    //     {
    //       id: 'disabled-menu',
    //       title: 'Disabled Menu',
    //       type: 'item',
    //       url: 'javascript:',
    //       classes: 'nav-item disabled',
    //       icon: 'feather icon-power',
    //       external: true
    //     },
    //     {
    //       id: 'sample-page',
    //       title: 'Sample Page',
    //       type: 'item',
    //       url: '/sample-page',
    //       classes: 'nav-item',
    //       icon: 'feather icon-sidebar'
    //     },
    //     {
    //       id: 'document',
    //       title: 'Document',
    //       type: 'item',
    //       classes: 'nav-item',
    //       url: DOCS_LINK,
    //       icon: 'feather icon-book',
    //       target: true,
    //       external: true
    //     }
    //   ]
    // }
];
